// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3voH1","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1-r5v"};